import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../../components/biblio/Layout";
import { Eye, Trash } from "../../../components/Icons";
import Pagination from "../../../components/Pagination";
import {dateFormat, notify} from "../../../helpers/Helper";
import DocumentStore from "../../../store/DocumentStore";

export default function Favorite() {
    const [page, setPage] = useState(1)
    const [documents, setDocuments] = useState([]);
    const [pagination, setPagination] = useState({});
    const [loading,setLoaging]=useState(false)

    useEffect(() => {
        init();
    }, [page])

    const init = async () => {
        setLoaging(true)
        const { data, pagination } = await DocumentStore.getFavoriteDocuments(page)
        setPagination(pagination)
        setDocuments(data);
        setLoaging(false)
    }

    const deleteFavorite = (id) => {
        DocumentStore.deleteFavorite(id).then(_ => { init(); notify('Succès', "Le document a été supprimé des favoris.", "success") })
    }
    const setCurrentPage = (page) => {
        setPage(page);
    }

    const Body = () => {
        return (
            <>
                <div className="p-1 breadcrumbs xs-font">
                    <Link to="/bibliotheque" className="textPrimary fw-bold">Accueil</Link> <span>/ Rapports favoris</span>
                </div>
                <div className="content-body">
                    <h4 className="page-title">Rapports favoris</h4>
                    <div className="container mt-3">
                        <div className="card p-2">
                            <table className={`table table-striped ${loading ? 'loading' : ''}`}>
                                <thead>
                                    <tr>
                                        <th>Titre</th>
                                        <th>Description</th>
                                        <th>Année d'edition</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {documents.map(document =>
                                        <tr key={document.rapport.id}>
                                            <td>{document.rapport.libelle}</td>
                                            <td>{document.rapport.description.substring(0, 300)}</td>
                                            <td>{dateFormat(document.rapport.createdAt)}</td>
                                            <td>
                                                <Link style={{ color: '#fff', marginRight: '10px' }} className="btn btn-info mr-3" to={`/bibliotheque/documents/${document.rapport.id}`}>
                                                    <Eye />
                                                </Link>
                                                <button className="btn btn-sm btn-danger" onClick={() => deleteFavorite(document.id)}><Trash/></button>
                                            </td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                            <Pagination setCurrentPage={setCurrentPage} pagination={pagination} />
                        </div>
                    </div>
                </div>

            </>
        );
    }
    return <Layout body={<Body />} />

}